import geoDetect from '@/js/helpers/geoDetect';

export default function () {
  return new Promise((resolve, reject) => {
    geoDetect((city, { lat, lng }) => resolve({ city, coordinates: [lat, lng] }), reject);
  });
}
